import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  ConfigProvider,
  Modal,
  notification,
  Space,
  Table,
  Input,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  deleteDishonestPersonnel,
  getDishonestPersonnelList,
} from "../../../common/request";
import ResponseCode from "../../../common/response-code";
import Styles from "./ConfigDishonestPersonnel.module.scss";
import DishonestPersonnelModal from "./DishonestPersonnelModal";

/** 机构管理-机构配置-不诚信人员 */
function ConfigDishonestPersonnel({ orgItem, modalVisible }) {
  const modalRef = useRef();
  const [tableData, setTableData] = useState({});
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [searchIdCard, setSearchIdCard] = useState("");

  useEffect(() => {
    if (orgItem.id && modalVisible) getTableData();
  }, [orgItem, modalVisible, pageNum, pageSize]);

  /** 错误提示 */
  const errorModal = (content) => {
    Modal.error({ title: "错误", content });
  };

  /** 获取列表数据 */
  const getTableData = async (init = false) => {
    setLoading(true);
    try {
      if (init) setPageNum(1);
      const params = {
        orgId: orgItem.id,
        pageNum,
        pageSize,
        name: searchName,
        idCard: searchIdCard,
      };
      const res = await getDishonestPersonnelList(params);
      setLoading(false);
      if (res.code !== ResponseCode.success) return errorModal(res.msg);
      setTableData(res.data);
    } catch (error) {
      setLoading(false);
      console.error(error);
      errorModal("网络错误，查询列表失败");
    }
  };

  /** 分页器变化 */
  const paginationChange = (num, size) => {
    setPageSize(size);
    setPageNum(size === pageSize ? num : 1);
  };

  /** 打开弹窗 */
  const openModal = (type, data) => {
    modalRef.current.showModal(type, data);
  };

  /** 删除人员确认 */
  const deleteConfirm = (item) => {
    const { name, id } = item;
    Modal.confirm({
      title: "删除人员",
      content: `确定要删除不诚信人员【${name}】吗？`,
      onOk: () => deletePersonnel(id),
    });
  };

  /** 删除人员 */
  const deletePersonnel = async (id) => {
    setLoading(true);
    try {
      const res = await deleteDishonestPersonnel({ id });
      setLoading(false);
      if (res.code !== ResponseCode.success) errorModal(res.msg);
      notification.success({ message: "操作成功" });
      getTableData();
    } catch (error) {
      setLoading(false);
      console.error(error);
      errorModal("网络错误，删除人员失败");
    }
  };

  /** 表格操作栏按钮 */
  const operationBtnList = [
    { label: "编辑", fn: (row) => openModal("update", row) },
    { label: "删除", fn: (row) => deleteConfirm(row) },
  ];

  /** 表格项 */
  const columns = [
    { title: "姓名", dataIndex: "name" },
    { title: "身份证号", dataIndex: "idCard" },
    { title: "考试名称", dataIndex: "examName" },
    { title: "违纪类型", dataIndex: "violationType" },
    { title: "禁考起始日期", dataIndex: "examBanStartTime" },
    { title: "禁考截止日期", dataIndex: "examBanEndTime" },
    {
      title: "操作",
      dataIndex: "operation",
      render: (_, row) => {
        return (
          <Space className={"d-flex justify-content-end"}>
            {operationBtnList.map((item) => (
              <Button
                type={"primary"}
                ghost
                danger={item.label === "删除"}
                onClick={() => item.fn(row)}
                key={item.label}
              >
                {item.label}
              </Button>
            ))}
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <div className={Styles.headerBar}>
        <div>
          <Input
            className={Styles.searcher}
            placeholder="请输入姓名"
            allowClear
            onChange={(e) => setSearchName(e.target.value.trim())}
          />
          <Input
            className={Styles.searcher}
            placeholder="请输入身份证"
            allowClear
            onChange={(e) => setSearchIdCard(e.target.value.trim())}
          />
          <Button type="primary" onClick={() => getTableData(true)}>
            查询
          </Button>
        </div>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => openModal("insert")}
        >
          新增不诚信人员
        </Button>
      </div>

      <ConfigProvider componentSize={"small"}>
        <Table
          columns={columns}
          dataSource={tableData.elements}
          rowKey={(record) => record.id}
          loading={loading}
          pagination={{
            showTotal: (total) => `共 ${total} 条`,
            size: "normal",
            showSizeChanger: true,
            total: tableData.totalElements,
            pageSize,
            current: pageNum,
            onChange: paginationChange,
          }}
        />
      </ConfigProvider>

      <DishonestPersonnelModal
        ref={modalRef}
        orgId={orgItem.id}
        success={getTableData}
      />
    </>
  );
}

export default ConfigDishonestPersonnel;
